export function setCustomers(state, payload) {
  state.customers = payload;
}

export function addCustomerDetails(state, payload) {
  payload.customer = payload.customer.addAddress(payload.customerDetails.address);
  payload.customer = payload.customer.addContactInfo(payload.customerDetails);
  state.customerUserDetails = payload.customer;
}

export function clearCustomers(state) {
  state.customers = [];
}
export function clearCustomerUserDetails(state) {
  state.customerUserDetails = undefined;
}

export function setIsLoadingCustomers(state, payload) {
  state.isLoadingCustomers = payload;
}

export function addPoliciesToCustomer(state, payload) {
  if (state.customers) {
    state.customers.forEach((customer) => {
      if (customer.customerNumber === payload.customerNumber) {
        customer = customer.addPolicies(payload.policies);
      }
    });
  }
}

export function addFinancialSummaryToCustomer(state, payload) {
  if (state.customers) {
    state.customers.forEach((customer) => {
      if (customer.customerNumber === payload.customerNumber) {
        customer = customer.addFinancialSummary(payload.financialSummary);
      }
    });
  }
}
